// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TiptapEditorController from "./tiptap_editor_controller"
application.register("tiptap-editor", TiptapEditorController)

import KeywordsInputController from "./keywords_input_controller"
application.register("keywords-input", KeywordsInputController)

import FaqBuilderController from "./faq_builder_controller"
application.register("faq-builder", FaqBuilderController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)
